import { selectExperiments } from '../selectExperiments';
import { IAppState } from 'shared/common/state';
import { COMMON_CPD_LANDING_EXPERIMENT } from 'shared/constants/experiments';
import { isAbUseExperimentGroup } from 'shared/utils/experiments/isAbUseExperimentGroup';

// TODO: Удалить эксперимент в CD-266903.
export function selectCommonCPDLandingExperiment(state: IAppState) {
  const experiments = selectExperiments(state);

  return isAbUseExperimentGroup(experiments, COMMON_CPD_LANDING_EXPERIMENT, 'B');
}
